import React from 'react';
import { Drawer, Row, Col, Button, Icon } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { filterVisibleSelector } from '../../store/selectors';
import {
  resetFilter,
  setFilterVisible,
  setSelectedQuestion,
} from '../../store/actions';
import SelectPeriod from '../SelectPeriod/SelectPeriod';
import SelectQuestionsTypes from '../SelectQuestionsTypes/SelectQuestionsTypes';
import SelectQuestionsStates from '../SelectQuestionsStates/SelectQuestionsStates';
import SelectCompanies from '../SelectCompanies/SelectCompanies';
import SelectStreets from '../SelectStreets/SelectStreets';
import SelectHouses from '../SelectHouses/SelectHouses';
import SelectAddresses from '../SelectAddresses/SelectAddresses';
import { notificationConstants } from '../../../../constants/notification.constants';
import SelectAnswerStatus from '../SelectAnswerStatus/SelectAnswerStatus';
import CloseQuestionRejectedCheckbox from '../CloseQuestionRejectedCheckbox/CloseQuestionRejectedCheckbox';
import SelectReaction from '../SelectReaction/SelectReaction';
import styles from './QuestionsDrawer.module.scss';

const QuestionsDrawer = () => {
  const dispatch = useDispatch();

  const filterVisible = useSelector(filterVisibleSelector);
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const showCompanies = userInfo.ServiceCompanyFilter;

  const handleClose = () => {
    dispatch(setFilterVisible(false));
  };

  const handleResetFilterBtnClick = () => {
    dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null });
    dispatch(setSelectedQuestion(null));
    dispatch(resetFilter());
  };

  return (
    <Drawer
      title="Фильтр вопросов"
      visible={filterVisible}
      onClose={handleClose}
      width={520}
      drawerStyle={{ backgroundColor: '#f9f9f9' }}
      bodyStyle={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <SelectPeriod />
        </Col>
        <Col span={12}>
          <SelectQuestionsTypes className={styles.fullWidth} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <SelectQuestionsStates className={styles.fullWidth} />
        </Col>
        {showCompanies && (
          <Col span={12}>
            <SelectCompanies className={styles.fullWidth} />
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <SelectStreets className={styles.fullWidth} />
        </Col>
        <Col span={6}>
          <SelectHouses className={styles.fullWidth} />
        </Col>
        <Col span={6}>
          <SelectAddresses className={styles.fullWidth} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <SelectAnswerStatus className={styles.fullWidth} />
        </Col>
        <Col span={12}>
          <SelectReaction className={styles.fullWidth} />
        </Col>
      </Row>
      <Row>
        <Col>
          <CloseQuestionRejectedCheckbox />
        </Col>
      </Row>
      <Row>
        <Col offset={14} span={10}>
          <Button
            className={styles.resetBtn}
            onClick={handleResetFilterBtnClick}
          >
            <Icon type="sync" className={styles.resetFilterIcon} />
            Сбросить фильтр
          </Button>
        </Col>
      </Row>
    </Drawer>
  );
};

export default QuestionsDrawer;
